
import moment from 'moment'

export default {

	timeToDecimal (dtInicio, dtFim){

		var dec = moment(dtInicio)
		var pouso = moment(dtFim)

		var diff = pouso.diff(dec)
		var duration = moment.duration(diff)

		var $hours   = duration.hours()
		var $days   = duration.days()
		var $minutes = duration.minutes()

		if($hours == 0 && $days == 0 && $minutes == 0){
			return 0.0
		}

		var $decimo_hora = 0;

		if ($minutes >= 4 && $minutes <= 9)
		{
			$decimo_hora = 1;
		}
		else if ($minutes >= 10 && $minutes <=15)
		{
			$decimo_hora = 2;
		}
		else if ($minutes >= 16 && $minutes <=21)
		{
			$decimo_hora = 3;
		}
		else if ($minutes >= 22 && $minutes <=27)
		{
			$decimo_hora = 4;
		}
		else if ($minutes >= 28 && $minutes <=33)
		{
			$decimo_hora = 5;
		}
		else if ($minutes >= 34 && $minutes <=39)
		{
			$decimo_hora = 6;
		}
		else if ($minutes >= 40 && $minutes <=45)
		{
			$decimo_hora = 7;
		}
		else if ($minutes >= 46 && $minutes <=51)
		{
			$decimo_hora = 8;
		}
		else if ($minutes >= 52 && $minutes <=57)
		{
			$decimo_hora = 9;
		}
		else if (($minutes >= 58))
		{
			$decimo_hora = 0;
			$hours++;
		}
		else if ($hours != 0)
		{
			$decimo_hora = 0;

		}else
		{
			$decimo_hora = 0;
		}

		return Number($hours + ($days * 24))+'.'+ $decimo_hora;
	},

}



// WEBPACK FOOTER //
// ./src/library/calculo.js